module.exports = __webpack_public_path__ + "img/gzh.1c59f203.jpg";